/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UploadCardTransactionEvidenceImageRequest
 */
export interface UploadCardTransactionEvidenceImageRequest {
    /**
     * 
     * @type {Array<File>}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'files'?: Array<File>;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'electronicMethod'?: UploadCardTransactionEvidenceImageRequestElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'documentSize'?: UploadCardTransactionEvidenceImageRequestDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'heightMillis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'widthMillis'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'note'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'irrelevantToLedger'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'uploadedByRecipient'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'uploadedFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'invoiceIssuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'invoiceIssuerRegistrationNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UploadCardTransactionEvidenceImageRequest
     */
    'asQualified'?: boolean | null;
}

export const UploadCardTransactionEvidenceImageRequestElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type UploadCardTransactionEvidenceImageRequestElectronicMethodEnum = typeof UploadCardTransactionEvidenceImageRequestElectronicMethodEnum[keyof typeof UploadCardTransactionEvidenceImageRequestElectronicMethodEnum];
export const UploadCardTransactionEvidenceImageRequestDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type UploadCardTransactionEvidenceImageRequestDocumentSizeEnum = typeof UploadCardTransactionEvidenceImageRequestDocumentSizeEnum[keyof typeof UploadCardTransactionEvidenceImageRequestDocumentSizeEnum];


